// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (min-width: 480px) {
    .languageCheckContainer {
        width: 70%;
    }
}
@media (min-width: 768px) {
    .languageCheckContainer {
        width: 50%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Core/Components/LanguageCheck/LanguageCheck.css"],"names":[],"mappings":";AACA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":["\n@media (min-width: 480px) {\n    .languageCheckContainer {\n        width: 70%;\n    }\n}\n@media (min-width: 768px) {\n    .languageCheckContainer {\n        width: 50%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
